import { render, staticRenderFns } from "./ShoppingTable.vue?vue&type=template&id=5c91b698&scoped=true&"
import script from "./ShoppingTable.vue?vue&type=script&lang=js&"
export * from "./ShoppingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91b698",
  null
  
)

export default component.exports